<template>
  <div>
    <ion-list>
      <div :class="readingStyle">
        <div class="article-content settings">
          <h2 style="text-align: center; margin-top: 1em;">SAMPLE TEXT</h2>
          <p>The Constitution is the fundamental and paramount law of the nation to which all other laws must conform and in accordance with which all private rights determined and all public authority administered.
Laws that do not conform to the Constitution should be stricken down for being unconstitutional.</p>
        </div>
      </div>
      <ion-radio-group v-if="this.theme !== 'dark'" v-ion-model="readingMode" @ionChange="($event)=>{onChange($event, 'readingMode')}">
        <ion-list-header>
          <h5>Reading Mode</h5>
        </ion-list-header>
        <ion-item>
          <ion-label>Normal</ion-label>
          <ion-radio value="normal"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Sepia</ion-label>
          <ion-radio value="sepia"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Dark</ion-label>
          <ion-radio value="dark"></ion-radio>
        </ion-item>
      </ion-radio-group>

      <ion-radio-group v-ion-model="textSize" @ionChange="($event)=>{onChange($event, 'textSize')}">
        <ion-list-header>
          <h5>Text Size</h5>
        </ion-list-header>
        <ion-item>
          <ion-label>Normal</ion-label>
          <ion-radio value="normal"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Medium</ion-label>
          <ion-radio value="medium"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Large</ion-label>
          <ion-radio value="large"></ion-radio>
        </ion-item>
      </ion-radio-group>

      <ion-radio-group v-ion-model="theme" @ionChange="($event)=>{onChange($event, 'theme')}">
        <ion-list-header>
          <h5>Theme</h5>
        </ion-list-header>
        <ion-item>
          <ion-label>Light</ion-label>
          <ion-radio value="light"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Dark</ion-label>
          <ion-radio value="dark"></ion-radio>
        </ion-item>
      </ion-radio-group>
      <ion-list-header>
        <h5>Notebook Categories</h5>
        <ion-button fill="clear" @click="manageCategories">EDIT</ion-button>
      </ion-list-header>
      <ion-item lines="none">
        <div class="notebook-preview">
          <div v-for="(o, idx) in options" :key="idx" :class="o.value >= 1000 ? 'custom-categories' : 'default-categories'">
            <p v-if="o.parent" class="sub-categories">{{ o.label }}</p>
            <p v-else>{{ o.label }}</p>
          </div>
        </div>
      </ion-item>
    </ion-list>

    <div id="popupManage" style="display:none" v-if="popupContent">
      <popup-manage></popup-manage>
    </div>
  </div>
</template>

<script>
import Manage from "./notebooks/PopupManageCategories.vue";

export default {
  data() {
    return {
      readingMode: "normal",
      textSize: "normal",
      theme: "light",
      popupContent: true,
      options: []
    };
  },

  methods: {
    onChange(e, field) {
      this[field] = e.target.value
      this.$store.commit("settings/save", {
        readingMode: this.readingMode,
        textSize: this.textSize,
        [field]: e.target.value
      });
    },

    async manageCategories(evt) {
      evt.preventDefault();
      if(!this.$store.getters['user/isAuthenticated']) {
        this.$router.push('/profile/login');
        return;
      }
      
      this.popupContent = false; // re-create always
      setTimeout(async () => {
        this.popupContent = true;
        const popover = await this.$ionic.showPopover(null, {
          template: "popupManage",
          cssClass: "mobile-wide-width-popup",
          translucent: true
        });
        
        popover.onDidDismiss().then((result) => {
          this.getCategories();
        });

      }, 200);
    },

    async getCategories() {
      const res = await this.$http({
        method: "GET",
        url: this.$config.api.url + "/categories",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      
      this.options = [
        {label: 'All', value: 1},
        {label: 'Political Law', value: 2},
        {label: 'Labor Law', value: 3},
        {label: 'Civil Law', value: 4},
        {label: 'Taxation Law', value: 5},
        {label: 'Commercial Law', value: 6},
        {label: 'Criminal Law', value: 7},
        {label: 'Remedial Law', value: 8},
        {label: 'Legal Ethics', value: 9},
        {label: 'Others', value: 10}
      ]

      if(res) {
        if(res.data) {
          if(res.data.result.length > 0) {
            const categories = res.data.result;
            const opts = this.options;
            categories.forEach(el => {
              if(el.parent) {
                const idx = opts.findIndex(x => x.value === el.parent);
                opts.splice(idx+1, 0, {label: el.title, value: el.id, parent: el.parent});
              } else {
                opts.push({label: el.title, value: el.id});
              }
            });
          }
        }
      }
    }
  },

  computed: {
    readingStyle() {
      let reading = this.$store.state.settings.settings.readingMode;

      if(this.$store.state.settings.settings.theme == 'dark') {
        reading = this.$store.state.settings.settings.theme;
      }
      return [
        "reading-" +
          (reading || "normal"),
        "textsize-" + (this.$store.state.settings.settings.textSize || "normal")
      ];
    }
  },

  mounted() {
    this.readingMode = this.$store.state.settings.settings.readingMode || "normal";
    this.textSize = this.$store.state.settings.settings.textSize || "normal";
    this.theme = this.$store.state.settings.settings.theme || "normal";
    this.$store.commit("ui/setHeaderTitle", "Settings");
    this.getCategories();
  },

  beforeDestroy() {
    this.$store.commit("ui/setHeaderTitle", "");
    this.$store.commit("settings/save", {
      readingMode: this.readingMode,
      textSize: this.textSize,
      theme: this.theme
    });
  },

  components: {
    "popup-manage": Manage
  }
};
</script>
<style>
.article-content.settings {
  padding: 1em;
}

.notebook-preview {
  padding: 0.5em 1em;
  border: 1px solid rgba(0,0,0,0.2);
  width: 100%;
}

.notebook-preview p {
  margin: 1em 0;
  padding-left: 0.75em;
}

.custom-categories p{
  border-left: 2px solid var(--ion-color-primary);
}

.sub-categories {
  margin: 0 0 0 1.3em !important;
}
</style>
